module.exports = __webpack_public_path__ + "assets/img/right.ec609ca6.png";